export const TYPES = {
  STRING: 'String',
  INT: 'Int',
  LONG: 'Long',
  FLOAT: 'Float',
  DOUBLE: 'Double',
  BOOLEAN: 'Boolean',
}
